// extracted by mini-css-extract-plugin
export var contact = "contact-module--contact--8-VZx";
export var contactBackground = "contact-module--contact-background--zqDRu";
export var head = "contact-module--head--3J9NW";
export var socials = "contact-module--socials--iUN4e";
export var subhead = "contact-module--subhead--ytMfd";